import AccessLandListControl from './AccessLandListControl.vue';
import DateControl from './DateControl.vue';
import EnumControl from './EnumControl.vue';
import FloorAreaControl from './FloorAreaControl.vue';
import MatrixControl from './MatrixControl.vue';
import MultiEnumControl from './MultiEnumControl.vue';
import MultiTextControl from './MultiTextControl.vue';
import NumberControl from './NumberControl.vue';
import NumberOrRangeControl from './NumberOrRangeControl.vue';
import ParcelNumbersControl from './ParcelNumbersControl.vue';
import ReconstructionListControl from './ReconstructionListControl.vue';
import TextControl from './TextControl.vue';

const controlComponents: Record<string, any> = {
    'date': DateControl,
    'enum': EnumControl,
    'number': NumberControl,
    'number-or-range': NumberOrRangeControl,
    'number_or_range': NumberOrRangeControl,
    'floor-area': FloorAreaControl,
    'floor_area': FloorAreaControl,
    'matrix': MatrixControl,
    'multi-enum': MultiEnumControl,
    'multi_enum': MultiEnumControl,
    'text': TextControl,
    'reconstruction-list': ReconstructionListControl,
    'reconstruction_list': ReconstructionListControl,
    'access-land-list': AccessLandListControl,
    'access_land_list': AccessLandListControl,
    'multi-text': MultiTextControl,
    'multi_text': MultiTextControl,
    'parcel-numbers': ParcelNumbersControl,
    'parcel_numbers': ParcelNumbersControl,
};

/**
 * The control of a parameter by the type of its definition
 */
export function resolveControl(type: string): any {
    const component = controlComponents[type];
    if (!component) {
        console.warn(`Unknown parameter control type: "${type}"`);
    }
    return component || type + '-control';
}
